import { isEqual } from 'lodash';

import type {
  EmergencyRecoverySyncContext,
  EmergencyState,
} from 'features/emergency/interfaces';

export const EMERGENCY_RECOVERY_SYNC_KEYS = [
  'phoneNumbers',
  'connectionPoint',
  'calledConnectionPoints',
  'registeredAddress',
  'isAddressVerificationNeeded',
  'isEmergencyOccurredAtRegisteredLocation',
  'isGeoCoordinateAvailable',
  'verify911Address',
  'coordinates',
] as const satisfies ReadonlyArray<keyof EmergencyRecoverySyncContext>;

export type EmergencyRecoverySyncKey =
  (typeof EMERGENCY_RECOVERY_SYNC_KEYS)[number];

export const pickEmergencyRecoverySyncContext = (
  source: Pick<EmergencyState, EmergencyRecoverySyncKey>
): EmergencyRecoverySyncContext => {
  const context = {} as EmergencyRecoverySyncContext;

  for (const key of EMERGENCY_RECOVERY_SYNC_KEYS) {
    context[key] = source[key] as never;
  }

  return context;
};

export const areEmergencyRecoverySyncContextsEqual = (
  a: EmergencyRecoverySyncContext,
  b: EmergencyRecoverySyncContext
): boolean => isEqual(a, b);
